import React from 'react';
import styled from '@emotion/styled';
import { H3 } from '../../../../ui';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';

interface ICheckpointQueueDescriptionProps {
	name: string;
	isOpen: boolean;
}

export const CheckpointQueueDescription = ({
	name,
	isOpen,
}: ICheckpointQueueDescriptionProps) => {
	const { t } = useTranslation();

	return (
		<StyledCheckpointQueueDescription>
			<H3>{name}</H3>
			<p>
				{isOpen
					? t('security_checkpoint_open')
					: t('security_checkpoint_closed')}
			</p>
		</StyledCheckpointQueueDescription>
	);
};

export const StyledCheckpointQueueDescription = styled.div`
	display: flex;
	flex-direction: column;

	flex-grow: 1;
	gap: 15px;

	h3 {
		margin-bottom: 4px;
	}
`;
